import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { RequestResult } from '@app/core/dto/RequestResult';
import { SessionStorageService } from '@app/core/services/session-storage.service';
import { KipUser } from '@app/kip/dto/KipUser';
import { SubscriberParameter } from '@app/kip/dto/SubscriberParameter';
import { SubscriberParamTypes } from '@app/kip/enums/SubscriberParamTypes';
import { KipUserService } from '@app/kip/services/kip-user.service';
import { SubscriberParameterService } from '@app/kip/services/subscriber-parameter.service';
import { vwTaskListItem } from '@app/kip/viewdto/vwCleaningState/vwTaskListItem';
import { RoleType } from '@app/shared/enums/roles';
import { RoleService } from '@app/shared/services/role.service';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { combineLatest, Subject, Subscription, takeUntil } from 'rxjs';

@AutoUnsubscribe()
@Component({
  selector: 'app-share-task-dialog',
  templateUrl: './share-task-dialog.component.html',
  styleUrls: ['./share-task-dialog.component.scss']
})
export class ShareTaskDialogComponent implements OnInit, OnDestroy {

  editorForm: FormGroup
 
  kipUsersFiltered: KipUser[] = [];
  taskShareMulti : boolean = false;

  _data: vwTaskListItem
  destroy$: Subject<boolean> = new Subject<boolean>();
    
  constructor(public dialogRef: MatDialogRef<ShareTaskDialogComponent>, @Inject(MAT_DIALOG_DATA) private data: vwTaskListItem,
    private fb: FormBuilder,
    public sessionStorageService: SessionStorageService,
    private kipUserService: KipUserService,
    private roleService: RoleService,
    private subscriberParameterService : SubscriberParameterService
  ) {
    this._data = data;

    this.editorForm = this.fb.group({
      AssignedTo: new FormControl('-1')
    })
  }
  //#region =============== Angular Lifecyle events ============================================================================
  ngOnInit(): void {
    this.loadAll()
  }
  ngOnDestroy(): void {
   
  }
  //#endregion =================================================================================================================

  //#region =============== List event hadlers   ===============================================================================
  //#endregion =================================================================================================================

  //#region =============== Form events ========================================================================================
  //#endregion =================================================================================================================

  //#region =============== Dialog events ======================================================================================
  //#endregion =================================================================================================================

  //#region =============== Validation    ======================================================================================
  //#endregion =================================================================================================================

  //#region =============== Functions  =========================================================================================
  loadAll() {


    let units: string;
    let hotels: string;
    if (this.sessionStorageService.multiHotel) {
      if (!this.sessionStorageService.IgnoreMultiHotel) {
        const sel: string[] = this.sessionStorageService.getFlattenedHotels()[0].value.toString().split("@")
        units = sel[0] + ',' + this.sessionStorageService.getSelectedUnit();
        hotels = sel[1] + ',' + this.sessionStorageService.getSelectedHotelId().toString()
      } else {
        units = this.sessionStorageService.getSelectedUnit();
        hotels = this.sessionStorageService.getSelectedHotelId().toString();
      }
    } else { // nem multihotel, csak a kiválasztott hotel
      var a = 0;
      if (this.sessionStorageService.ParentHotel?.trim().length > 0) {
        const parent: string[] = this.sessionStorageService.ParentHotel.trim().split(",")

        units = parent[0] + "," + this.sessionStorageService.getSelectedUnit();
        hotels = parent[1] + "," + this.sessionStorageService.getSelectedHotelId().toString();
      } else {
        units = this.sessionStorageService.getSelectedUnit();
        hotels = this.sessionStorageService.getSelectedHotelId().toString();
      }

    }

    const combinedSources = combineLatest({
      kipusers: this.kipUserService.loadAllMulti(units, hotels),
      subscriberParams: this.subscriberParameterService.loadByTypeCode(this.sessionStorageService.getSelectedUnit(),this.sessionStorageService.getSelectedHotelId(),
          SubscriberParamTypes.TASK_SHARE_MULTI
    )
    })
    combinedSources.pipe(takeUntil(this.destroy$)).subscribe(value => {
      const resUsers = value.kipusers as RequestResult
      const users = resUsers.Data as KipUser[];
      this.kipUsersFiltered = users.filter(u => this.roleService.isUserInRole(u.UserName, RoleType.TAKARITO))
     

      const resSubsParam = value.subscriberParams as SubscriberParameter;
     
      this.taskShareMulti = resSubsParam.Param_Int_Value == 0 ? false : true
      if( this.taskShareMulti) {
         this.editorForm.controls["AssignedTo"].patchValue([])
      }  else {
         this.editorForm.controls["AssignedTo"].patchValue(this.kipUsersFiltered[0]?.UserId)
      }
    })


  }
  //#endregion =================================================================================================================


  cancel() {
    this.dialogRef.close(undefined)
  }

  submit() {
    this.dialogRef.close(this.editorForm.controls["AssignedTo"].value)
  }
}
